// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"351":"174c9c29","702":"f5f55833"}[chunkId] + ".chunk.css");